// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"707":"65ffffb8","765":"fa977dab"}[chunkId] + ".css";
};